var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C14.4783 0.00435161 10.0043 4.47781 10 10C10.0087 15.5178 14.4783 19.9913 20 20C25.5217 19.9913 29.9913 15.5222 30 10C29.9957 4.47781 25.5217 0.00435161 20 0ZM0 35.2941C0 29.0588 8.95556 24 20 24C31.0444 24 40 29.0588 40 35.2941C40 37.8931 37.8931 40 35.2941 40H4.70588C2.1069 40 0 37.8931 0 35.2941Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/User_Icon.9fbed5770c0ac22cfdb2e8cf4c7c8c4c.svg";
export { ForwardRef as ReactComponent };